import { render } from "./hotel.vue?vue&type=template&id=01105278&scoped=true"
import script from "./hotel.vue?vue&type=script&lang=js"
export * from "./hotel.vue?vue&type=script&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=01105278&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01105278"

export default script